import React from 'react';
import { useCart } from '../../context/CartContext';
import './BrandHeader.css';

const BrandHeader = ({ brand }) => {
  const { totalItems, setCartOpen } = useCart();

  return (
    <header className="brand-header" style={{ background: brand.primaryColor || '#111' }}>
      <div className="container brand-header-inner">
        <a href="/" className="brand-header-back">← All Brands</a>
        <a href={`/${brand.id}`} className="brand-header-logo">
          {brand.logoUrl ? (
            <img src={brand.logoUrl} alt={brand.name} className="brand-header-logo-img" />
          ) : (
            <span className="brand-header-logo-text">{brand.name}</span>
          )}
          <div className="brand-header-divider" />
          <span className="brand-header-catering">Catering</span>
        </a>
        <button className="brand-header-cart" onClick={() => setCartOpen(true)}
          style={{ borderColor: 'rgba(255,255,255,0.3)', color: 'var(--white)' }}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 01-8 0"/>
          </svg>
          <span>View Enquiry</span>
          {totalItems > 0 && <span className="brand-header-cart-count">{totalItems}</span>}
        </button>
      </div>
    </header>
  );
};

export default BrandHeader;
